module.exports = __webpack_public_path__ + "static/media/qr-code-coding-programming-development-web-internet-svgrepo-com.ed674318.svg";